export class ServiceEditModel {
    constructor() {
        this.name = "";
        this.latestVersion = null;
        this.description = null;
        this.url = null;
    }
}
export default class ServiceEdit extends ServiceEditModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
